import {
    SET_REPORT_STATE,
    REPORT_STATE_ALL_YEARS
} from './report-state-actions';

const initialState = REPORT_STATE_ALL_YEARS;

/**
 * ReportState Reducer
 *
 * State within report - currently only applies to Participation All Years which can have
 * 3 states: All years, All classes, Top 10 students
 *
 * Consumes SET_REPORT_STATE action
 *
 * @param {string} the current state; may be undefined when application starts
 * @param {object} action, an object with a type and a payload
 * @returns {string} - new state
 */
export default function(state = initialState, action) {
    if (!action) return state;

    switch (action.type) {
        case SET_REPORT_STATE:
            return action.payload;

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./containers/participation/all-classes/report-state/report-state-reducer.js